import React from 'react';
import { Link } from 'react-router-dom';

import { PersonOrgType } from '@ndvr/auth-api';

import { getClientTypeAlias, getPersonOrgName, personRoute, useHouseholdRoutePaths, useRequiredParams } from 'utils';
import { usePersonOrg } from 'views/person/person-queries';
import { AccountWithAumIncluded } from 'views/portfolio/account-aum-queries';

interface AccountOwnerProps {
    account: AccountWithAumIncluded;
}

const OwnerPersonOrgCard = ({ personOrgGUID }: { personOrgGUID: string }) => {
    const { data: personOrg } = usePersonOrg(personOrgGUID);
    const { globalAccountGUID } = useRequiredParams(['globalAccountGUID']);
    const { OwnersTabRoutePath } = useHouseholdRoutePaths();

    if (!personOrg) {
        return null;
    }
    const link =
        personOrg.personOrgType === PersonOrgType.PERSON
            ? personRoute(personOrg.personOrgGUID)
            : OwnersTabRoutePath(globalAccountGUID);

    return (
        <div className="flex flex-col gap-0.5">
            <Link to={link}>{getPersonOrgName(personOrg)}</Link>
            <div className="text-xs text-gray-500">{getClientTypeAlias(personOrg.personOrgType)}</div>
        </div>
    );
};

export const AccountOwner = ({ account }: AccountOwnerProps) => {
    if (!account.ownerPersonOrgGUID) {
        return null;
    }

    return <OwnerPersonOrgCard personOrgGUID={account.ownerPersonOrgGUID} />;
};
